import { Validator } from "../validator"

export enum OccupationalGroupError {
    BLANK = `occupational_group_error`,
}

class OccupationalGroupValidator implements Validator<string, OccupationalGroupError> {
    validate(entry: string): OccupationalGroupError | undefined {
        if (entry === ``) {
            return OccupationalGroupError.BLANK
        }
    }
}

export { OccupationalGroupValidator }